var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.order
    ? _c("div", [
        _c("div", { staticClass: "flex-start-center p-20 pl-25" }, [
          _vm.isTicket
            ? _c("div", { staticClass: "display-3 mr-10" }, [_vm._v("Ticket")])
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "display-3 mr-10" }, [
            _vm._v(
              "N° " +
                _vm._s(
                  _vm.order &&
                    _vm.order.OrderId.toLocaleString("en").replaceAll(",", "-")
                )
            ),
          ]),
          _vm._v(" "),
          _vm.order.OrderState == _vm.ORDER_STATES.STATE_CHARGEBACK
            ? _c("div", { staticClass: "pill color-white bg-bo-p1" }, [
                _vm._v("Chargeback\n\t\t"),
              ])
            : _vm._e(),
          _vm._v(" "),
          [
            _vm.ORDER_STATES.STATE_VALIDATED_UNCONFIRMED,
            _vm.ORDER_STATES.STATE_MODIFIABLE,
          ].includes(_vm.order.OrderState)
            ? _c("div", { staticClass: "pill color-white bg-bo-p1" }, [
                _vm._v("\n\t\t\tNon confirmé"),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.order.OrderState ==
          _vm.ORDER_STATES.STATE_PENDING_PAYMENT_CONFIRMATION
            ? _c("div", { staticClass: "pill color-white bg-bo-warning" }, [
                _vm._v("En attente de paiement"),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.order.OrderState == _vm.ORDER_STATES.STATE_CONFIRMED
            ? _c("div", { staticClass: "pill color-white bg-bo-s1" }, [
                _vm._v("En préparation"),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.order.OrderState == _vm.ORDER_STATES.STATE_DELIVERED
            ? _c("div", { staticClass: "pill color-white bg-bo-s2" }, [
                _vm._v("Confirmé "),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.order.OrderState == _vm.ORDER_STATES.STATE_CANCELLED
            ? _c("div", { staticClass: "pill color-white bg-bo-danger" }, [
                _vm._v("Annulé "),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.order.OrderState == _vm.ORDER_STATES.STATE_EXPIRED
            ? _c("div", { staticClass: "pill color-white bg-bo-p1" }, [
                _vm._v("Abandonné"),
              ])
            : _vm._e(),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }